<template>
  <card>
    <div class="filter-grid disable-ske TableProductFilters">
      <div>
        <span>Sku</span>
        <TableSearchField
          :value="sku"
          @input="(val) => $emit('update:sku', val)"
        />
      </div>

      <div>
        <span>Korte beschrijving</span>
        <TableSearchField
          :value="short_description"
          @input="(val) => $emit('update:short_description', val)"
        />
      </div>

      <div>
        <span>Beschrijving</span>
        <TableSearchField
          :value="description"
          @input="(val) => $emit('update:description', val)"
        />
      </div>

      <div>
        <span>URL</span>
        <TableSearchField
          :value="url"
          @input="(val) => $emit('update:url', val)"
        />
      </div>

      <div>
        <span>Aanbevolen verkoopprijs</span>
        <div class="d-flex w-100">
          <div class="min-max-original-field">
            <TableSearchField
              :value="recommended_retail_price"
              @input="(val) => $emit('update:recommended_retail_price', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_recommended_retail_price"
              @input="
                (val) => $emit('update:min_recommended_retail_price', val)
              "
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_recommended_retail_price"
              @input="
                (val) => $emit('update:max_recommended_retail_price', val)
              "
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div>
        <span>Aanbieding prijs</span>
        <div class="d-flex w-100">
          <div class="min-max-original-field">
            <TableSearchField
              :value="special_price"
              @input="(val) => $emit('update:special_price', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_special_price"
              @input="(val) => $emit('update:min_special_price', val)"
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_special_price"
              @input="(val) => $emit('update:max_special_price', val)"
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div>
        <span>Koop prijs</span>
        <div class="d-flex w-100">
          <div class="min-max-original-field">
            <TableSearchField
              :value="buy_price"
              @input="(val) => $emit('update:buy_price', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_buy_price"
              @input="(val) => $emit('update:min_buy_price', val)"
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_buy_price"
              @input="(val) => $emit('update:max_buy_price', val)"
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div>
        <span>Groothandel Prijs</span>
        <div class="d-flex">
          <div class="min-max-original-field">
            <TableSearchField
              :value="wholesale_price"
              @input="(val) => $emit('update:wholesale_price', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_wholesale_price"
              @input="(val) => $emit('update:min_wholesale_price', val)"
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_wholesale_price"
              @input="(val) => $emit('update:max_wholesale_price', val)"
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div>
          <span>Groothandel Voorraad</span>
          <div class="d-flex">
            <div class="min-max-original-field">
              <TableSearchField
                :value="wholesale_stock"
                @input="(val) => $emit('update:wholesale_stock', val)"
              />
            </div>

            <div class="min-max-filter mx-1">
              <TableSearchField
                :value="min_wholesale_stock"
                @input="(val) => $emit('update:min_wholesale_stock', val)"
                placeholder="Min"
              />
            </div>
            <div class="min-max-filter">
              <TableSearchField
                :value="max_wholesale_stock"
                @input="(val) => $emit('update:max_wholesale_stock', val)"
                placeholder="Max"
              />
            </div>
          </div>
      </div>

      <div>
        <span>Belasting</span>
        <TableSearchField
          :value="tax"
          @input="(val) => $emit('update:tax', val)"
        />
      </div>

      <div>
        <span>Ean 13</span>
        <TableSearchField
          :value="ean13"
          @input="(val) => $emit('update:ean13', val)"
        />
      </div>

      <div>
        <span>Wholesale Ean</span>
        <TableSearchField
          :value="wholesale_ean"
          @input="(val) => $emit('update:wholesale_ean', val)"
        />
      </div>

      <div>
        <span>Productvoorraad</span>
        <div class="d-flex">
            <div class="min-max-original-field">
            <TableSearchField
              :value="product_stock"
              @input="(val) => $emit('update:product_stock', val)"
            />
          </div>

          <div class="min-max-filter mx-1">
            <TableSearchField
              :value="min_product_stock"
              @input="(val) => $emit('update:min_product_stock', val)"
              placeholder="Min"
            />
          </div>

          <div class="min-max-filter">
            <TableSearchField
              :value="max_product_stock"
              @input="(val) => $emit('update:max_product_stock', val)"
              placeholder="Max"
            />
          </div>
        </div>
      </div>

      <div class="search-selector">
        <FormSearchSelector
          :value="brand"
          @input="(val) => $emit('update:brand', val)"
          :save-on-localstorage="true"
          id="brand"
          storage-id="product-filters-brand"
          :ske="true"
          label="Merk"
          placeholder="Zoek merk..."
          titleField="name"
          uid="uid"
          endpoint="/api/brands"
          v-slot="item"
        >
          <ProductListItem v-bind="item" />
        </FormSearchSelector>
      </div>

      <div class="search-selector">
        <FormSearchSelector
          :value="supplier"
          @input="(val) => $emit('update:supplier', val)"
          :save-on-localstorage="true"
          id="supplier"
          storage-id="product-filters-supplier"
          :ske="true"
          label="Leverancier"
          placeholder="Zoek leverancier..."
          titleField="name"
          uid="uid"
          endpoint="/api/suppliers"
          v-slot="item"
        >
          <ProductListItem v-bind="item" />
        </FormSearchSelector>
      </div>

      <div class="search-selector">
        <FormSearchSelector
          :value="category"
          @input="(val) => $emit('update:category', val)"
          :save-on-localstorage="true"
          id="categories"
          storage-id="product-filters-categories"
          :ske="true"
          label="Categorie"
          placeholder="Zoek Categorie..."
          title-field="category"
          uid="uid"
          endpoint="/api/categories"
          v-slot="item"
        >
          <ProductListItem v-bind="item" />
        </FormSearchSelector>
      </div>
    </div>
  </card>
</template>

<script>
import FormInput from "../Inputs/FormInput.vue";
import TableSearchField from "../Inputs/TableSearchField.vue";

import FormSearchSelector from "../Inputs/FormSearchSelector.vue";
import ProductListItem from "./ProductListItem.vue";

export default {
  props: {
    sku: String,
    short_description: String,
    description: String,
    url: String,
    tax: String,
    ean13: String,
    wholesale_ean: String,
    width: String,
    height: String,
    depth: String,
    weight: String,

    buy_price: String,
    min_buy_price: [Number, String],
    max_buy_price: [Number, String],

    special_price: [Number, String],
    min_special_price: [Number, String],
    max_special_price: [Number, String],

    recommended_retail_price: [Number, String],
    min_recommended_retail_price: [Number, String],
    max_recommended_retail_price: [Number, String],

    wholesale_price: [Number, String],
    min_wholesale_price: [Number, String],
    max_wholesale_price: [Number, String],

    wholesale_stock: [Number, String],
    min_wholesale_stock: [Number, String],
    max_wholesale_stock: [Number, String],

    product_stock: [Number, String],
    min_product_stock: [Number, String],
    max_product_stock: [Number, String],

    supplier: String,
    category: String,
    brand: String,
  },
  components: {
    ProductListItem,
    FormSearchSelector,
    FormInput,
    TableSearchField,
  },
  computed: {
    fields() {
      return Object.keys(this.$props);
    },
  },
};
</script>

<style>
.TableProductFilters .search-selector .label {
  font-weight: 400 !important;
  font-size: 0.875rem !important;
  text-transform: initial !important;
  padding: 0.25rem 0.5rem !important;
  padding-left: 0px !important;
}

.TableProductFilters .search-selector input {
  border-radius: 3px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  margin: 0px;
  height: 31px !important;
}

.TableProductFilters .search-selector {
  margin-top: -1px;
}
</style>

<style scoped>

.min-max-filter {
  width: 55px;
}

.min-max-original-field {
  flex-grow: 1;
}

.filter-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 12px;
  margin: 12px;
}

@media (max-width: 1300px) {
  .filter-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

@media (max-width: 1100px) {
  .filter-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media (max-width: 700px) {
  .filter-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 500px) {
  .filter-grid {
    grid-template-columns: 1fr;
  }
}
</style>
